import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import image from "../assets/prince2.jpeg"
import RatingStars from "../components/common/RatingStars";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import CourseDetailsCardPrince from "../components/core/Course/CourseDetailsCardPrince";
import ReactMarkdown from "react-markdown";
import { BsFillCaretRightFill, BsFillCaretRightSquareFill } from "react-icons/bs";
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import Footer from "../components/common/Footer";

const CourseDetails = () => {
  const [isActive, setIsActive] = useState(Array(0));
  const handleActive = () => {
    // console.log("called", id)
    setIsActive(

    );
  };

  return (
    <>
      <div className={`relative w-full bg-richblue-5`}>
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={image}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>

            <div
              className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblue-700`}
            >
              <div>
                <p className="text-4xl font-bold text-richblue-700 sm:text-[42px]">
                  PRINCE2® Foundation Training & Certification
                </p>
              </div>

              <p className={`text-richblue-500`}>
                With the increasing demand for structured and scalable project management frameworks, the PRINCE2® Foundation certification has emerged as a globally recognized standard for effective project delivery. This course is meticulously crafted to provide professionals with a comprehensive understanding of PRINCE2® principles, themes, and processes.<br></br>
                By mastering PRINCE2® methodologies, participants gain the ability to manage projects with clarity, control, and consistency. PRINCE2® equips individuals with the tools to handle complexity, mitigate risks, and adapt to changing project environments, making it an essential skill set for project success in any industry. </p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-yellow-25">5</span>
                <RatingStars Review_Count={5} Star_Size={20} />
                <span>{`(${5} reviews)`}</span>
                <span> | </span>
                <span>{`${200}+ Professionals Enrolled`}</span>
              </div>

              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at February 15, 2024 | 8:01 PM
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> English
                </p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-4 border-y border-y-richblue-300 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblue-700">
                Rs. {19999}
              </p>
              <button className="yellowButton">Enroll Now</button>
              <button className="blackButton">Request Free Demo</button>
            </div>
          </div>
          {/* Courses Card */}
          <div className="right-[2rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            <CourseDetailsCardPrince />
          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-richblue-700 lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblue-300 p-8">
            <p className="text-3xl font-semibold">Course Overview</p>
            <div className="mt-5">
              <ReactMarkdown>
                {
                  "In today’s dynamic business environment, organizations face increasing pressure to deliver projects efficiently while adapting to changing requirements and managing risks effectively. The growing complexity of projects and the need for structured methodologies have made it essential for teams to adopt proven frameworks that ensure consistent project success. "
                }
              </ReactMarkdown>
              <ReactMarkdown>
                {
                  "The PRINCE2® Foundation Certification is designed to address these challenges by providing professionals with a solid understanding of PRINCE2® principles, themes, and processes. This course equips participants with the knowledge and skills to manage projects with clarity, control, and confidence. By fostering a structured approach to project management, PRINCE2® enables organizations to deliver projects on time, within budget, and to the desired quality, ensuring alignment with business objectives and stakeholder expectations."
                }
              </ReactMarkdown>
            </div>
            <p className="text-3xl font-semibold mt-5">What you'll learn</p>
            <div className="flex flex-col gap-3 mt-5">
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Understand the structure and key terms of PRINCE2®.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Learn the characteristics and benefits of PRINCE2® projects.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Master the 7 PRINCE2® principles for effective project management.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Explore PRINCE2® roles, themes, and management products.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Understand the purpose and objectives of PRINCE2® processes.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Learn to manage project risks and uncertainties.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Prepare confidently for the PRINCE2® Foundation exam.
                </span>
              </p>
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Curriculum</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {8} {`module(s)`} &nbsp; |
                  </span>
                  <span>
                    {27} {`lecture(s)`} &nbsp; |
                  </span>
                  <span>{"1h 10m"} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}
                  >
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4 ">
              <CourseAccordionBar
                courseName={"Module 1: Introduction to PRINCE2®"}
                courseList={[
                  "Key concepts of projects and PRINCE2®",
                  "Overview of the PRINCE2® methodology",
                  "Benefits of adopting PRINCE2® for project management"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 2: PRINCE2® Principles"}
                courseList={[
                  "Understand the 7 PRINCE2® principles",
                  "How principles guide project management practices",
                  "Applying principles to real-world projects"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 3: PRINCE2® Themes"}
                courseList={[
                  "Overview of the 7 PRINCE2® themes",
                  "How themes are applied throughout the project lifecycle",
                  "Integrating themes into project management processes"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 4: PRINCE2® Processes"}
                courseList={[
                  "Overview of the 7 PRINCE2® processes",
                  "How processes are carried out across the project lifecycle",
                  "Tailoring processes to suit project needs"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
            </div>


          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CourseDetails;
